import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Redirects to the invitation acceptance page after a user completes
 * signup/login when they had a pending invitation token stored.
 *
 * Only fires on auth state transition (false → true), not on initial
 * page load when already authenticated.
 */
export const PendingInvitationRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const wasAuthenticated = useRef(isAuthenticated);

  useEffect(() => {
    const justAuthenticated = !wasAuthenticated.current && isAuthenticated;
    wasAuthenticated.current = isAuthenticated;

    if (!justAuthenticated) return;

    const pendingToken = sessionStorage.getItem('pendingInvitationToken');
    if (!pendingToken) return;

    if (location.pathname === '/invitation/accept') return;

    navigate(`/invitation/accept?token=${pendingToken}`, { replace: true });
  }, [isAuthenticated, location.pathname, navigate]);

  return null;
};

export default PendingInvitationRedirect;
